// app/javascript/controllers/modal_form_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { redirectUrl: String }

  connect() {
    this.element.addEventListener('turbo:submit-end', this.handleSubmitEnd.bind(this))
  }

  handleSubmitEnd(event) {
    if (event.detail.success) {
      // Обновляем URL без перезагрузки
      history.replaceState(null, '', this.redirectUrlValue)
    }
  }
}